import { ErrorHandler, inject, Injectable, Injector } from '@angular/core';
import { AnalyticsService } from './analytics.service';

@Injectable({
  providedIn: 'root',
})
export class TrackEventErrorHandlerService implements ErrorHandler {
  private readonly injector = inject(Injector);
  handleError(error: any): void {
    console.error(error);
    if (error?.message?.includes('ingest.data.dood.com/api/s/track')) {
      // do not log Jitsu events error, too much spamming
      return;
    }
    this.injector.get(AnalyticsService).log({
      level: 'error',
      label: 'TrackEventErrorHandlerService',
      message: {
        message: error?.message || error?.toString(),
        stack: error?.stack || null,
      },
    });
  }
}
